<template>
    <div class="routa-navbar">
        <span v-if="!showBack">{{ title }}</span>
        <span v-else class="pointer" @click.stop="$emit('back')"><i class="fa fa-arrow-left"/> {{ $t('common.back') }}</span>
    </div>
</template>
<script>
export default {
    name: 'Navbar',
    props: {
        title: {
            type: String,
            default: null
        },
        showBack: {
            type: Boolean,
            default: false
        }
    },
}
</script>
<style scoped>
.routa-navbar {
    background-color: #636364;
    font-size: 1.4em;
    line-height: 2;
    padding: .1em .5em;
    color: #FFFFFF;
    margin-left: -.7em;
    margin-right: -.7em;
}
</style>
